import ShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/ShippingGroups/ShippingGroups';

export default ShippingGroups;
